require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-magento-20-vs-shopify-should-you-upgrade-or-migrate.json") })
        }
      }, "path---blog-magento-20-vs-shopify-should-you-upgrade-or-migrate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-magento-20-vs-shopify-should-you-upgrade-or-migrate!./.cache/json/blog-magento-20-vs-shopify-should-you-upgrade-or-migrate.json
// module id = 476
// module chunks = 231608221292675